module.exports = __webpack_public_path__ + "static/media/ADDY.851b2f58.png";